<div
  *ngIf="showCouponSection"
  class="fixed inset-0 bg-black bg-opacity-50 z-[90]"
  (click)="onCancel()"
></div>

<section
  class="overflow-hidden bg-white w-full max-w-[400px] fixed right-0 top-0 h-full shadow-lg transform transition-transform duration-300 z-[100]"
  [class.invisible]="!showCouponSection"
  [class.pointer-events-none]="!showCouponSection"
  [ngClass]="showCouponSection ? 'translate-x-0' : 'translate-x-full'"
>
  <header
    class="flex flex-col justify-center px-6 py-4 w-full text-2xl font-bold leading-none bg-white border-b border-solid border-b-[#D4D4D4] text-blue-950 max-md:px-5 max-md:max-w-full"
  >
    <div
      class="flex gap-10 justify-between items-start w-full max-md:max-w-full"
    >
      <h1>Apply Coupons</h1>
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/8b6c08b8f398b49c9e660c78975ef334b44714be?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
        alt="Coupon icon"
        class="object-contain shrink-0 w-8 aspect-square"
        (click)="onCancel()"
      />
    </div>
  </header>

  <main class="px-6 mt-6 w-full max-md:px-5 max-md:max-w-full">
    <!-- Coupon Code Input -->
    <div class="w-full max-md:max-w-full" (click)="$event.stopPropagation()">
      <label
        class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700 max-md:max-w-full"
        for="couponCode"
      >
        Coupon Code
      </label>
      <div
        class="flex gap-2 items-center px-2 py-3 mt-1 w-full text-base font-medium rounded-lg text-neutral-500 max-md:max-w-full border border-gray-200"
        (click)="$event.stopPropagation()"
      >
        <input
          id="couponCode"
          placeholder="Enter Coupon Code"
          class="flex-1 shrink gap-2.5 self-stretch my-auto w-full basis-0 min-w-60 outline-none bg-transparent uppercase"
          [(ngModel)]="manualCouponCode"
          (ngModelChange)="onManualCouponChange()"
          (click)="$event.stopPropagation()"
        />
      </div>
    </div>

    <!-- Other Coupons Section -->
    <section class="mt-4 w-full max-md:max-w-full">
      <h2 class="text-lg font-bold leading-none text-black">Other Coupons</h2>

      <section class="flex flex-col justify-center py-2 w-full bg-white">
        <div
          class="flex gap-4 mb-1 items-start w-full rounded-lg border p-3 transition-all"
          [class.border-blue-500]="selectedCoupon === coupon"
          [class.bg-blue-50]="selectedCoupon === coupon"
          [class.border-gray-200]="selectedCoupon !== coupon"
          *ngFor="let coupon of availableCoupons; trackBy: trackByCoupon"
        >
          <div class="flex shrink-0 mt-2 w-6 h-6">
            <div
              class="w-6 h-6 border rounded border-gray-300 flex items-center justify-center cursor-pointer"
              [class.bg-blue-500]="selectedCoupon === coupon"
              [class.border-blue-500]="selectedCoupon === coupon"
              (click)="selectCoupon(coupon)"
            >
              <input
                type="checkbox"
                [checked]="selectedCoupon === coupon"
                class="opacity-0 absolute w-full"
              />
              <svg
                *ngIf="selectedCoupon === coupon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="white"
                class="w-4 h-4"
              >
                <path
                  fill-rule="evenodd"
                  d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>

          <div class="flex-1 shrink basis-0">
            <h3 class="text-base font-bold text-black">
              {{ coupon?.display_text }}
            </h3>
            <div
              class="mt-2 inline-flex items-center gap-2"
              *ngIf="coupon?.coupon_code"
            >
              <span
                class="text-xs font-semibold text-blue-600 bg-blue-50 px-3 py-1 rounded border border-blue-200 border-dashed"
              >
                "{{ coupon?.coupon_code }}"
              </span>
            </div>

            <div
              class="flex gap-1 items-center mt-1 w-full text-sm font-medium leading-none"
            >
              <p class="self-stretch text-emerald-800">
                Save ₹{{ coupon?.savings }} with this code
              </p>
            </div>
          </div>

          <!-- Remove Button - Shows only for currently applied coupon -->
          <button
            *ngIf="
              currentSelectedCoupon &&
              selectedCoupon === coupon &&
              (currentSelectedCoupon.coupon_code === coupon.coupon_code ||
                currentSelectedCoupon.row_id === coupon.row_id)
            "
            type="button"
            class="flex items-center justify-center w-8 h-8 text-red-600 hover:bg-red-50 rounded-full transition-colors"
            (click)="removeCoupon(); $event.stopPropagation()"
            title="Remove coupon"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </section>
    </section>
  </main>

  <!-- Footer Section -->
  <footer
    class="flex flex-wrap absolute bottom-0 gap-2 items-center px-6 py-2 mt-36 w-full bg-white border-t border-solid border-t-[#C0C5C7] max-md:px-5 max-md:max-w-full max-md:mt-10"
  >
    <div
      class="flex-1 shrink self-stretch my-auto basis-6"
      [class.text-emerald-800]="selectedCoupon"
      [class.text-gray-400]="!canApplyCoupon()"
    >
      <p class="text-sm font-medium leading-none">Your Saving</p>
      <p class="text-lg font-bold leading-none" *ngIf="selectedCoupon">
        ₹ {{ selectedCoupon?.savings || 0 }}
      </p>
      <p
        class="text-lg font-bold leading-none"
        *ngIf="!selectedCoupon && manualCouponCode.trim()"
      >
        Enter code to see savings
      </p>
      <p
        class="text-lg font-bold leading-none"
        *ngIf="!selectedCoupon && !manualCouponCode.trim()"
      >
        Select a coupon
      </p>
    </div>
    <!-- <button
      *ngIf="currentSelectedCoupon && selectedCoupon"
      class="flex gap-1 justify-center items-center self-stretch p-3 my-auto text-base font-bold text-center text-red-600 border-2 border-red-600 whitespace-nowrap rounded-lg bg-white w-[120px]"
      (click)="removeCoupon()"
    >
      Remove
    </button> -->
    <button
      class="flex gap-1 justify-center items-center self-stretch p-3 my-auto text-base font-bold text-center text-white whitespace-nowrap rounded-lg w-[200px]"
      [class.bg-blue-950]="canApplyCoupon()"
      [class.bg-gray-400]="!canApplyCoupon()"
      [class.cursor-not-allowed]="!canApplyCoupon()"
      (click)="applyCoupon()"
      [disabled]="!canApplyCoupon()"
    >
      Apply
    </button>
  </footer>
</section>
